// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

import VerticalSpacer from '../../components/vertical-spacer/vertical-spacer';
import Divider from '../../components/divider/divider';
import Paragraph from '../../components/paragraph/paragraph';
import Row from '../../components/row/row';

import {
  stringInputSpec,
  stringTextAreaSpec,
  boolCheckboxSpec,
} from '../../lib/editing-configs';

import './story.less';

const Story = ({
  children,
  title,
  description,
  centeredInParent,
  standardMaxWidths,
}) => {
  const anchor = title.toLowerCase().replace(/\s+/g, '-');
  return (
    <Row
      id={anchor}
      standardMaxWidths={standardMaxWidths}
      centeredInParent={centeredInParent}
    >
      <Paragraph
        header={
          <span className="story__anchor">
            <a href={`#${anchor}`}>¶</a>
            {title}
          </span>
        }
        copyStyle="copy-h2"
        body={description}
        dangerouslyAllowHTMLIn={{ body: true }}
      />
      <VerticalSpacer mobile="p-18" tablet="p-18" desktop="p-18" />
      {children}
      <VerticalSpacer mobile="p-18" tablet="p-18" desktop="p-18" />
      <Divider />
      <VerticalSpacer mobile="p-18" tablet="p-18" desktop="p-18" />
    </Row>
  );
};

Story.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  standardMaxWidths: PropTypes.bool,
  centeredInParent: PropTypes.bool,
};

Story.defaultProps = {
  description: '',
};

Story.getEditingConfig = () => [
  stringInputSpec('title', 'Story title'),
  stringTextAreaSpec('description', 'Description'),
  boolCheckboxSpec('standardMaxWidths', 'Restrict width?'),
  boolCheckboxSpec('centeredInParent', 'Centered in parent?'),
];

Story.isContainer = true;

export default Story;
